<div class="custom-control custom-switch">
  <input class="custom-control-input" type="checkbox" role="switch" [id]="id" [(ngModel)]="value" [checked]="value" (change)="onChange(value)">
  <label class="custom-control-label" [for]="id">
    <ng-content></ng-content>
  </label>
</div>
